import React from 'react';
import { useMontos } from '../../context/MontosContext';

// Piezas compartidas de Rentabilidad (12-oct-2026)
export const pesos = v => `$ ${Math.round(Number(v) || 0).toLocaleString('es-AR')}`;
export const km = v => `${(Number(v) || 0).toLocaleString('es-AR', { maximumFractionDigits: 1 })} km`;
export const horas = v => {
    if (v == null) return '—';
    const h = Math.floor(v); const m = Math.round((v - h) * 60);
    return m ? `${h} h ${m} min` : `${h} h`;
};
export const fechaLarga = f => {
    const [a, m, d] = String(f).slice(0, 10).split('-').map(Number);
    const t = new Date(a, m - 1, d).toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric', month: 'short' });
    return t.charAt(0).toUpperCase() + t.slice(1);
};
// Colores por anillo de distancia a la base
export const COLOR_ANILLO = ['#16A34A', '#2563EB', '#D48800', '#C9341F'];
export const colorKm = k => (k == null ? '#9CA3AF' : k <= 5 ? COLOR_ANILLO[0] : k <= 10 ? COLOR_ANILLO[1] : k <= 20 ? COLOR_ANILLO[2] : COLOR_ANILLO[3]);

/** Número grande con título y aclaración. `plata` respeta el "ocultar montos". */
export function Kpi({ titulo, valor, sub, plata = false, tono }) {
    const { montosVisibles } = useMontos();
    const texto = plata && !montosVisibles ? '••••' : valor;
    const color = tono === 'bien' ? 'text-[color:var(--etapa-listo)]' : tono === 'mal' ? 'text-brand-red' : 'text-ink';
    return (
        <div className="p-3.5 rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] min-w-0">
            <p className="text-label font-black uppercase tracking-widest text-muted truncate">{titulo}</p>
            <p className={`mt-1 text-title font-black leading-tight ${color} truncate`}>{texto}</p>
            {sub && <p className="mt-0.5 text-caption text-muted leading-snug">{sub}</p>}
        </div>
    );
}

/** Monto en línea que respeta "ocultar montos". */
export function Plata({ v, className = '' }) {
    const { montosVisibles } = useMontos();
    return <span className={className}>{montosVisibles ? pesos(v) : '••••'}</span>;
}

export function Aviso({ children, tono = 'info' }) {
    const cls = tono === 'alerta'
        ? 'bg-[var(--warning-bg)] text-[var(--warning-tx)]'
        : 'bg-panel text-secondary';
    return <div className={`p-3 rounded-xl text-caption font-bold leading-snug ${cls}`}>{children}</div>;
}
